import axios from 'axios';

export default {

    getDates() {
        return axios.get(process.env.VUE_APP_API_URI + '/api/parcourir/dates');
    },

    //Permet de récupérer les commerciaux suivis
    getFavoritesCommercials() {
        return axios.get(process.env.VUE_APP_API_URI + '/api/commercials/favorites');
    },

    //Permet d'ajouter un commercial aix commerciaux suivi
    setFavoriteCommercials(commercialId) {
        return axios.get(process.env.VUE_APP_API_URI + '/api/commercials/favorites/add/' + commercialId);
    },

    getPersonalMonitoringResult(userId, monitoringResultId){
        return axios.get(process.env.VUE_APP_API_URI + '/api/parcourir/monitoring-results/' + monitoringResultId + '/users/' + userId);
    },

    getPersonalMonitoringResultCriteriaDetails(userId, monitoringResultId, criteria){
        return axios.get(process.env.VUE_APP_API_URI + '/api/parcourir/monitoring-results/' + monitoringResultId + '/users/' + userId + '/' + criteria);
    },

    getPersonalCriteria(userId, criteria, startDate = null, endDate = null){
        let params = '';
        if(startDate && endDate) {
            params = params + '?start=' + startDate + '&end=' + endDate;
        }
        return axios.get(process.env.VUE_APP_API_URI + '/api/parcourir/monitoring-results/graphics/users/' + userId + '/' + criteria + params);
    },

    getPersonalMonitoringResultCriteriaClassement(userId, monitoringResultId, criteria){
        return axios.get(process.env.VUE_APP_API_URI + '/api/parcourir/monitoring-results/' + monitoringResultId + '/users/' + userId + '/' + criteria + '/classement');
    },

    getLastResult(){
        return axios.get(process.env.VUE_APP_API_URI + '/api/parcourir/monitoring-results/last');
    },
}
